import useAnswerForQuestion from './useAnswerForQuestion';
import useCurrentGroup from './useCurrentGroup';

/**
 * Checks if the questiongroup has no mandatory questions and if all answers are empty
 * @returns true if the questiongroup is skippable
 */
const useIsGroupSkippable = (): boolean => {
  const currentGroup = useCurrentGroup();
  const getAnswerForQuestion = useAnswerForQuestion();

  const areAllQuestionsNonMandatory = currentGroup?.questions.every(
    ({ rules }) => !rules.mandatory,
  );
  const isNothingAnswered = currentGroup?.questions?.every(({ id, index }) => {
    const answer = getAnswerForQuestion(id, index)?.answer;
    // When answer is an empty array it is unanswered
    if (Array.isArray(answer) && answer.length === 0) return true;

    // When answer is an empty string it is unanswered
    if (answer === '') return true;

    // empty answers are unanswered
    if (answer == null) return true;
    return false;
  });
  return isNothingAnswered && areAllQuestionsNonMandatory;
};

export default useIsGroupSkippable;
